import { render, staticRenderFns } from "./AddToDiagnoseButton.vue?vue&type=template&id=76d126f9&scoped=true&"
import script from "./AddToDiagnoseButton.vue?vue&type=script&lang=js&"
export * from "./AddToDiagnoseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d126f9",
  null
  
)

export default component.exports